import { Link as RouterLink, LinkProps as RouterLinkProps, NavLink } from "react-router-dom";
import { Box, Button, Link, LinkProps, Menu, menuClasses, MenuItem, menuItemClasses, MenuItemProps, styled } from "@mui/material";

import { NavigationContainer } from "fond/widgets";

type NavLinkProps = LinkProps &
  RouterLinkProps & {
    icon?: React.ReactNode;
  };

export const NewNavigationContainer = styled(NavigationContainer)`
  .account-avatar {
    background-color: ${({ theme }) => theme.palette.biarri.primary.red};
  }
`;

export const NavLinkWrapper = ({ ...rest }: NavLinkProps): JSX.Element => {
  return <Link component={NavLink} {...rest} />;
};

export const StyledNavLink = styled(NavLinkWrapper)`
  color: ${({ theme }) => theme.palette.text.primary};
  display: flex;
  font-size: ${({ theme }) => theme.typography.size.normal};
  font-weight: 500;
  padding: ${({ theme }) => theme.spacing(1)};
  align-items: center;
  margin: ${({ theme }) => theme.spacing(0.5, -1)};
  border-radius: ${({ theme }) => theme.custom.shape.borderRadius.medium};

  &:hover,
  &:focus,
  &.active:hover,
  &.active:focus {
    color: ${({ theme }) => theme.palette.text.primary};
    text-decoration: underline;
    background-color: rgba(255, 255, 255, 0.6);
  }

  .icon {
    display: inline-flex;
    color: rgba(0, 0, 0, 0.25);
    padding-right: ${({ theme }) => theme.spacing(1)};
  }

  &.active {
    background-color: ${({ theme }) => theme.palette.common.white};
    box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.05);
  }

  &.active .icon {
    color: ${({ theme }) => theme.palette.biarri.primary.red};
  }
`;

export const SidebarElement = styled(Box)`
  &:not(:empty) {
    margin: ${({ theme }) => theme.spacing(1, 0, 2.5)};
  }

  &:last-of-type {
    margin-bottom: ${({ theme }) => theme.spacing(0)};
  }
`;

type SupportNavigationLinkProps = MenuItemProps &
  Partial<RouterLinkProps> & {
    // Make the 'to' prop optional to allow for custom links
    to?: RouterLinkProps["to"];
  };
export const SupportNavigationLink = ({ children, to, ...rest }: SupportNavigationLinkProps) => {
  return (
    <MenuItem component={to ? RouterLink : Link} to={to} {...rest}>
      {children}
    </MenuItem>
  );
};

export const SupportNavigationMenu = styled(Menu)`
  & .${menuClasses.list} {
    min-width: 220px;
  }
`;

export const SupportNavigationItem = styled(SupportNavigationLink)`
  display: block;
  border-radius: ${({ theme }) => theme.custom.shape.borderRadius.medium};
  color: ${({ theme }) => theme.palette.primary.main};
  padding: ${({ theme }) => theme.spacing(0.75, 1)};
  margin: ${({ theme }) => theme.spacing(0.5, 1)};

  &:hover,
  &.${menuItemClasses.focusVisible} {
    text-decoration: underline;
    background-color: ${({ theme }) => theme.custom.action.primaryHover};
  }
`;

export const HelpButton = styled(Button)`
  gap: ${({ theme }) => theme.spacing(1.5)};
  justify-content: flex-start;
  padding-left: 0;

  &:hover,
  &:focus {
    background-color: ${({ theme }) => theme.custom.action.primaryHover};
  }
`;
